import type { FunctionComponent } from "react";

export const FinnLogo: FunctionComponent = () => {
  return (
    <img src="/images/brand/finn.png" className={"w-32 md:w-[161px] h-10 md:h-[50px]"} alt="Finn" />
  );
};
